import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const KEY = "lp-cookie-consent";

export const CookieConsent = () => {
  const { t } = useLang();
  const [show, setShow] = useState(false);
  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setShow(true); } catch { /* ignore */ }
  }, []);

  const decide = (choice) => {
    try { localStorage.setItem(KEY, choice); } catch { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    // Sits ABOVE the feedback bubble in the bottom-right corner — it used to cover it, and on short
    // pages it landed on the last row of content.
    <div className="fixed bottom-4 sm:bottom-24 inset-x-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] lp-fade-up pointer-events-none" data-testid="cookie-consent">
      <div className="bg-[#0f2a1a] text-white rounded-2xl shadow-2xl border border-white/10 p-5 pointer-events-auto">
        <div className="flex items-start gap-3">
          <span className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center shrink-0"><Cookie size={20} className="text-[#f5b942]" /></span>
          <div className="min-w-0">
            <p className="font-bold">{t("ck.title")}</p>
            <p className="text-sm text-emerald-100/80 mt-1">
              {t("ck.body")} <Link to="/privacy" className="underline font-semibold hover:text-white">{t("ck.privacy")}</Link>.
            </p>
            <div className="flex flex-wrap items-center gap-2 mt-4">
              <button onClick={() => decide("all")} data-testid="cookie-accept-btn" className="bg-[#16a34a] hover:bg-[#15803d] text-white text-sm font-semibold px-4 py-2 rounded-xl transition-colors">{t("ck.acceptAll")}</button>
              <button onClick={() => decide("essential")} data-testid="cookie-essential-btn" className="bg-white/10 hover:bg-white/20 text-white text-sm font-semibold px-4 py-2 rounded-xl transition-colors">{t("ck.essential")}</button>
            </div>
          </div>
          <button onClick={() => decide("essential")} aria-label={t("ck.dismiss")} className="text-white/60 hover:text-white transition-colors shrink-0"><X size={18} /></button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
